// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import basePermissionTree from 'config/authorization/base-permission-tree';
import baseSideMenu from 'config/navigation/base-side-menu';

// ==============================|| SLICE - MAIN ||============================== //
// *** IMPORTANT ***
// Side menu IDs will be used in various scenarios beyond simple rendering,
// so it is extremely important to be careful with changing any ID here
// For example, the values in the authorization tree must exactly match the IDs in the side menu,
// so that it can be dynamically generated from the authorizations set to the user

const initialState = {
    selectedSideMenuItem: 'dashboard',
    sideMenuIsOpen: false,
    appIsLoading: false,
    sideMenu: baseSideMenu,
    permissionTree: basePermissionTree
};

const main = createSlice({
    name: 'main',
    initialState,
    reducers: {
        selectSideMenuItem(state, action) {
            state.selectedSideMenuItem = action?.payload;
        },
        toogleSideMenuIsOpen(state, action) {
            state.sideMenuIsOpen = Boolean(action?.payload);
        },
        toogleAppIsLoading(state, action) {
            state.appIsLoading = Boolean(action?.payload);
        },
        setSideMenu(state, action) {
            state.sideMenu = action?.payload;
        },
        updateSideMenu(state, action) {
            const updateMenuItem = (menuItems, updItem) => {
                menuItems.forEach((menuItem, index) => {
                    if (menuItem?.id === updItem?.id) {
                        menuItems.splice(index, 1, { ...menuItem, ...updItem });
                    } else if (menuItem?.children) {
                        updateMenuItem(menuItem.children, updItem);
                    }
                });
            };

            action?.payload.forEach((updItem) => {
                updateMenuItem(state.sideMenu, updItem);
            });
        },
        setPermissionTree(state, action) {
            state.permissionTree = action?.payload;
        },
        updatePermissionTree(state, action) {
            const updateAuthorizationItem = (authItems, updItem) => {
                authItems.forEach((authItem, index) => {
                    if (authItem?.value === updItem?.value) {
                        authItems.splice(index, 1, { ...authItem, ...updItem });
                    } else if (authItem?.children) {
                        updateAuthorizationItem(authItem.children, updItem);
                    }
                });
            };

            action?.payload.forEach((updItem) => {
                updateAuthorizationItem(state.permissionTree, updItem);
            });
        }
    }
});

export default main.reducer;

export const {
    selectSideMenuItem,
    toogleSideMenuIsOpen,
    toogleAppIsLoading,
    setSideMenu,
    updateSideMenu,
    setPermissionTree,
    updatePermissionTree
} = main.actions;

export const getPermissionTreeValues = (permTree, nodeValue = '', excludeActions = []) => {
    const result = [];

    const collectLeafNodes = (node) => {
        if (node?.children?.length > 0) {
            node.children.forEach((child) => collectLeafNodes(child));
        } else if (!excludeActions?.some((action) => node.value.indexOf(action) >= 0)) {
            result.push(node.value);
        }
    };

    const findNodeAndCollectLeafNodes = (nodes) => {
        nodes.forEach((node) => {
            if (node?.value === nodeValue) {
                collectLeafNodes(node);
            } else if (node?.children?.length > 0) {
                findNodeAndCollectLeafNodes(node.children);
            }
        });
    };

    findNodeAndCollectLeafNodes(permTree);

    return result;
};

export const getAllPermissionTreeValues = (permTree, excludeActions = []) => {
    const result = [];

    const collectLeafNodes = (node) => {
        if (node?.children?.length > 0) {
            node.children.forEach((child) => collectLeafNodes(child));
        } else if (!excludeActions?.some((action) => node.value.indexOf(action) >= 0)) {
            result.push(node.value);
        }
    };

    permTree.forEach((node) => collectLeafNodes(node));

    return result;
};
